import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import FormCheck from "react-bootstrap/FormCheck";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import dayjs from "dayjs";
import { Helmet } from "react-helmet";
import Kba from "../../Components/Elements/Kba";

import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
// import FeaturedPromoMixes from "../Home/FeaturedPromoMixes";

import "./SearchPage.less";
import axios from "axios";
import SearchResultsContainer from "./SearchResultsContainer";
import queryString from "query-string";
import TrackImage from "~/Components/Elements/Global/TrackImage";
import { CdAndLpButtonArtist } from "~/Components/CdAndLp";

const LOCAL_STORE_SEARCH_MODE_ADV = "chim_track_search_mode_adv";

const KeepDiggin = ({ artist }) => (<Row style={{ marginTop: "40px" }}>
  <Col xs={12} sm={{ span: 10, offset: 1 }}>
    <h3>Keep Digging...</h3>
  </Col>
  <Col xs={12} sm={{ span: 10, offset: 1 }} className="">
    <p>Try looking for a digital or physical copy at one of these affiliates:</p>
    <div style={{ textAlign: 'center' }}>
      <div className="apple_music_button" style={{ marginRight: 36 }}>
        <a href={`https://music.apple.com/us/search?at=10lsNn&itsct=music_box_link&itscg=30200&at=10lsNn&ct=totd&ls=1&term=${artist}`} target="_blank">
          <img src="https://tools.applemediaservices.com/api/badges/listen-on-apple-music/mono-black/en-us?size=250x83&amp;releaseDate=1504224000" alt="Listen on Apple Music" />
        </a>
      </div>
      <div className="juno_button" style={{ marginRight: 36 }}>
        <a href={`https://www.junodownload.com/search/?q%5Ball%5D%5B%5D=${encodeURIComponent(artist)}&solrorder=relevancy&ref=dc`} target="_blank">
          <img src="https://www.dreamchimney.com/mainpage/kba/btn-buy-juno.jpg" alt="Buy on Juno Download" />
        </a>
      </div>
      <div className="cdlp_music_button">
        <CdAndLpButtonArtist artist={artist} />
      </div>
    </div>
  </Col>
</Row>)

class SearchPage extends Component {
  constructor(...args) {
    super(...args);
    this.myRef = React.createRef();
    this.state = {
      advancedMode: localStorage.getItem(LOCAL_STORE_SEARCH_MODE_ADV) === "true" || !localStorage.getItem(LOCAL_STORE_SEARCH_MODE_ADV),
      hasSearched: false,
      numResults: 0,
      page: 1,
      searchParams: {},
      chims: [],
    };
  }

  nextPage = (e) => {
    e.stopPropagation();
    const nextPage = this.state.page + 1;
    const searchParams = { ...this.state.searchParams, page: nextPage };
    this.setState({ page: nextPage, searchParams });
  };

  componentDidMount() {
    // get list of all chimneys
    const getChimsUrlProd = `//www.dreamchimney.com/api/tracks/admin/build/chims`;
    axios.get(getChimsUrlProd).then((d) => {
      const chims = d.data;
      this.setState({ chims });
    });

    const queryStringParams = queryString.parse(this.props.location.search);
    if (Object.keys(queryStringParams).length) {
      this.setState({ advancedMode: false, hasSearched: true, searchParams: queryStringParams });
    }
  }

  toggleMode() {
    this.setState({ advancedMode: !this.state.advancedMode });
    localStorage.setItem(LOCAL_STORE_SEARCH_MODE_ADV, !this.state.advancedMode);
  }

  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    this.myRef.current.scrollIntoView();

    const form = event.currentTarget;
    form.title.value = form.title.value.trim();
    form.artist.value = form.artist.value.trim();
    form.album.value = form.album.value.trim();

    let searchParams = {};
    if (form.title.value) {
      searchParams = { ...searchParams, title: form.title.value };
    }
    if (form.exact_title.checked) {
      searchParams = { ...searchParams, exact_title: "y" };
    }
    if (form.exact_artist.checked) {
      searchParams = { ...searchParams, exact_artist: "y" };
    }
    if (form.exact_album.checked) {
      searchParams = { ...searchParams, exact_album: "y" };
    }
    if (form.exact_genre.checked) {
      searchParams = { ...searchParams, exact_genre: "y" };
    }

    if (form.artist.value) {
      searchParams = { ...searchParams, artist: form.artist.value };
    }
    if (form.album.value) {
      searchParams = { ...searchParams, album: form.album.value };
    }
    if (form.genre.value) {
      searchParams = { ...searchParams, genre: form.genre.value };
    }
    if (form.chim.value) {
      searchParams = { ...searchParams, chimney: form.chim.value };
    }

    var queryString = Object.keys(searchParams)
      .map((key) => key + "=" + searchParams[key])
      .join("&");
    this.props.history.push("?" + queryString);

    if (Object.keys(searchParams).length) {
      this.setState({ hasSearched: true, searchParams });
    }
  }

  render() {
    const { page, searchParams } = this.state;
    const options = {
      defaultSortName: "title",
      defaultSortOrder: "desc",
      sortIndicator: true,
      isOnlyHead: false,
    };

    function coverFormatter(cell, row) {
      if (row['chimdir'] === 'promotracks' && row['promo_id']) {
        return (
          <>
            <a href={`/promo/${row['slug']}`}>
              <img src={`https://www.dreamchimney.com/tracks/images/promo-tracks/${row['promo_id']}.jpg`} width={75} />
            </a>
          </>
        );
      }
      else {
        return (
          <>
            <TrackImage track={row} width={75} />
          </>
        );
      }
    }
    function trackFormatter(cell, row) {
      if (row['chimdir'] === 'promotracks' && row['promo_id']) {
        return (
          <>
            <a href={`/promo/${row['slug']}`}>{row.title}</a>
          </>
        );
      }
      return (
        <>
          <Link to={row.id}>{row.title}</Link>
        </>
      );
    }
    function dateFormatter(cell, row) {
      return dayjs(cell.split("T")[0]).format("MMM D, YYYY");
    }
    function chimNameFormatter(cell, row) {
      if (row.full_name) return `${row.full_name} Chimney`;
      if (row.guest_name) return `${row.guest_name}`;
    }
    const rowStyle = (row, rowIndex) => {
      const style = {};
      if (rowIndex % 2 === 0) {
        style.backgroundColor = "#fcfcfc";
      }
      return style;
    };

    function showResultsTable(results, loading, page) {
      if (!loading && results.length === 0) {
        return false;
      }
      return page > 1 || (!loading && results.length > 0);
    }

    const columns = [
      {
        dataField: "cover",
        text: "",
        formatter: coverFormatter,
        sort: false,
        classes: "col-search-cover",
      },
      {
        dataField: "date",
        text: "Date Posted",
        formatter: dateFormatter,
        sort: true,
        classes: "col-search-date",
      },
      {
        dataField: "title",
        text: "Title",
        formatter: trackFormatter,
        sort: true,
      },
      {
        dataField: "artist",
        text: "Artist",
        sort: true,
      },
      {
        dataField: "album",
        text: "Album",
        hidden: window.innerWidth < 768,
        classes: "col-search-album",
      },
      {
        dataField: "genre",
        text: "Genre",
        hidden: window.innerWidth < 768,
        sort: true,
        classes: "col-search-genre",
      },
      {
        dataField: "chimdir",
        text: "Posted by",
        formatter: chimNameFormatter,
        sort: true,
        classes: "col-search-chimdir",
      },
    ];
    const defaultSorted = [
      {
        dataField: "date",
        order: "desc",
      },
    ];

    return (
      <div className="search-page-component">
        <Helmet>
          <title>Search : Track of the Day | Dream Chimney</title>
        </Helmet>
        <Form className="search-form" noValidate onSubmit={(e) => this.handleSubmit(e)}>
          <Row>
            <Col xs={12}>
              <div className="page-header">
                <h2>Search</h2>
              </div>
            </Col>
            <Col xs={12} lg={{ span: 4, offset: 2 }} className="">
              <Form.Group controlId="title">
                <Form.Label>Track Title</Form.Label>
                <Form.Control type="text" autoComplete="off" defaultValue={searchParams.title} />
                <Form.Text className="text-muted">
                  <FormCheck>
                    <FormCheck.Input type="checkbox" id="exact_title" defaultChecked={searchParams.exact_title} />
                    <FormCheck.Label>Exact Match</FormCheck.Label>
                  </FormCheck>
                </Form.Text>
              </Form.Group>

              <Form.Group controlId="album" className={this.state.advancedMode ? `showField` : `hideField`}>
                <Form.Label>Album</Form.Label>
                <Form.Control type="text" autoComplete="off" />
                <Form.Text className="text-muted">
                  <FormCheck>
                    <FormCheck.Input type="checkbox" id="exact_album" defaultChecked={searchParams.exact_album} />
                    <FormCheck.Label>Exact Match</FormCheck.Label>
                  </FormCheck>
                </Form.Text>
              </Form.Group>

              <Form.Group controlId="genre" className={this.state.advancedMode ? `showField` : `hideField`}>
                <Form.Label>Genre</Form.Label>
                <Form.Control type="text" autoComplete="off" defaultValue={searchParams.genre} />
                <Form.Text className="text-muted">
                  <FormCheck>
                    <FormCheck.Input type="checkbox" id="exact_genre" defaultChecked={searchParams.exact_genre} />
                    <FormCheck.Label>Exact Match</FormCheck.Label>
                  </FormCheck>
                </Form.Text>
              </Form.Group>
            </Col>
            <Col xs={12} lg={{ span: 4 }} className="">
              <Form.Group controlId="artist">
                <Form.Label>Artist</Form.Label>
                <Form.Control type="text" autoComplete="off" defaultValue={searchParams.artist} />
                <Form.Text className="text-muted">
                  <FormCheck>
                    <FormCheck.Input type="checkbox" id="exact_artist" defaultChecked={searchParams.exact_artist} />
                    <FormCheck.Label>Exact Match</FormCheck.Label>
                  </FormCheck>
                </Form.Text>
              </Form.Group>

              <Form.Group controlId="chim" className={this.state.advancedMode ? `showField` : `hideField`}>
                <Form.Label>Posted by</Form.Label>
                <Form.Control as="select">
                  <option value="">Select Chimney</option>
                  {this.state.chims &&
                    this.state.chims.map((chim) => (
                      <option
                        key={chim.chim_dir}
                        value={chim.chim_dir}
                        selected={searchParams.chimney === chim.chim_dir ? "selected" : null}
                      >
                        {chim.full_name} Chimney
                      </option>
                    ))}
                </Form.Control>
              </Form.Group>
            </Col>
            {/* <Col xs={12} sm={{ span: 4, offset: 2 }} className="">
              <Form.Group controlId="album">
                <Form.Label>Album</Form.Label>
                <Form.Control type="text" autoComplete="off" />
              </Form.Group>
            </Col> */}
          </Row>
          <Row>
            <Col xs={12} lg={{ span: 8, offset: 2 }} className="submitButton">
              <div className="toggleMode" onClick={() => this.toggleMode()}>
                {this.state.advancedMode ? `- Basic Search` : `+ Advanced Search`}
              </div>

              <Button variant="primary" type="submit">
                Search
              </Button>
            </Col>
          </Row>

          <Row>
            <Col xs={12} style={{ marginTop: 40 }}>
              <Kba margin="30px auto" />
            </Col>
          </Row>
        </Form>
        <div ref={this.myRef}>{` `}</div>
        {this.state.hasSearched && (
          <Row>
            <Col xs={12}>
              <div className="totd-header sm">Results</div>
            </Col>
            <Col xs={12}>
              <SearchResultsContainer
                params={this.state.searchParams}
                useLoadMore="true"
                render={({ results, loading }) => (
                  <div>
                    {showResultsTable(results, loading, this.state.page) && (
                      <BootstrapTable
                        ref="table"
                        keyField="id"
                        data={results}
                        options={options}
                        columns={columns.map((col) => {
                          if (col.dataField !== "date") {
                            col.sort = results.length % 30 !== 0;
                          }
                          return col;
                        })}
                        rowStyle={rowStyle}
                        defaultSorted={defaultSorted}
                        bootstrap4
                      />
                    )}
                    {loading && (
                      <div className="loading">
                        <Spinner animation="border" variant="secondary" />
                      </div>
                    )}

                    {!loading && results.length === 0 && (
                      <><div className="results-padding results-empty">
                        <strong>ZERO.</strong> Nothing in our system that matches. Maybe try a different spelling?
                      </div>
                        {/* <KeepDiggin artist={searchParams.artist} /> */}
                      </>
                    )}

                    {!loading && results.length !== 0 && results.length % 30 === 0 && (
                      <div className="results-padding results-more text-center">
                        <Button variant="primary" onClick={(e) => this.nextPage(e)}>
                          Load More Results
                        </Button>
                      </div>
                    )}
                  </div>
                )}
              />
            </Col>
          </Row>
        )}
        {searchParams.artist && (
          <Row style={{ marginTop: 40, backgroundColor: '#f0f0f0', paddingBottom: 30 }}>
            <Col xs={12} sm={{ span: 10, offset: 1 }} className="">
              <KeepDiggin artist={searchParams.artist} />
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

export default withRouter(SearchPage);
